import VueRouter from 'vue-router';
import BillingsPendingManualConfig from './pages/BillingsPendingManualConfig';
import ConfigManualBilling from './pages/ConfigManualBilling';
import Students from './pages/Students';
import StudentView from './pages/Students/StudentView';
import InstitutionsList from './pages/Institutions/InstitutionsList';
import InstitutionView from './pages/Institutions/InstitutionView';
import BusinessRuleGroup from './pages/Institutions/BusinessRuleGroup';
import Recipients from './pages/Institutions/InstitutionView/Recipients';
import Reenrollment from './pages/Institutions/InstitutionView/Reenrollment';
import AgreementRules from './pages/Institutions/InstitutionView/AgreementRules';
import DigitalContracts from './pages/Institutions/InstitutionView/DigitalContracts';
import UpdateFcvBillingsWithJacadInBatch from './pages/Institutions/InstitutionView/UpdateFcvBillingsWithJacadInBatch';
import ResendEvent from './pages/ResendApiEvent';
import SendGenericHsm from './pages/SendGenericHsm.vue';
import Parcelamento from './pages/Parcelamento';
import ParcelamentoStudentView from './pages/Parcelamento/StudentView';
import AdminUsers from './pages/AdminUsers';
import FeeClosings from './pages/FeeClosings';
import FeeClosingView from './pages/FeeClosings/Show';
import Login from './pages/Login';

export default new VueRouter({
  routes: [
    { path: '/', name: 'students', component: Students },
    { path: '/alunos/:id', name: 'student-details', component: StudentView },
    { path: '/parcelamento', name: 'parcelamento', component: Parcelamento },
    { path: '/parcelamento/:id', name: 'parcelamento-student-details', component: ParcelamentoStudentView },
    { path: '/instituicoes', component: InstitutionsList },
    {
      path: '/instituicao/:id',
      component: InstitutionView,
      children: [
        { path: 'regras-de-negocio', name: 'business-rule-group', component: BusinessRuleGroup },
        { path: 'recebedores', name: 'recipients', component: Recipients },
        { path: 'rematricula', name: 'reenrollment', component: Reenrollment },
        { path: 'regras-de-acordo', name: 'agreement-rules', component: AgreementRules },
        { path: 'contratos-digitais', name: 'digital-contracts', component: DigitalContracts },
        {
          path: 'atualizar-conforme-jacad-em-lote',
          name: 'update-fcv-billings-with-jacad-in-batch',
          component: UpdateFcvBillingsWithJacadInBatch,
        },
      ],
    },
    { path: '/criar-contrato-manual', component: BillingsPendingManualConfig },
    { path: '/criar-contrato-manual/:billingId', component: ConfigManualBilling },
    { path: '/reenviar-eventos-api', component: ResendEvent },
    { path: '/enviar-hsm-generico', component: SendGenericHsm },
    { path: '/atualizar-role-usuario', component: AdminUsers },
    { path: '/fechamento-taxa-quero-pago', name: 'fee-closings', component: FeeClosings },
    { path: '/fechamento-taxa-quero-pago/:id', name: 'fee-closing-details', component: FeeClosingView },
    {
      path: '/login', name: 'login', component: Login, meta: { layout: 'clean' },
    },
  ],
});
